import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild } from "@angular/core";
import { CclNavbarSecondaryService, CclSideNavItem, CclMessageService } from "certain-common-library";
import { SharedService } from "../../../../modules/shared/services/shared.service";
import { Subscription } from "rxjs";
import { DragScrollComponent } from "ngx-drag-scroll";
import { SessionService } from "../../../../modules/shared/services/session-service";
import { CatalogService } from "../../../../modules/shared/services/catalog.service";
@Component({
    selector: "tab-section",
    templateUrl: "./tab-section.view.html",
    styleUrls: []
})
export class TabSectionView implements OnInit, AfterViewInit, OnDestroy {
    private subscription: Subscription;
    tabConfig: any;
    private tabsData: any = {};
    private selectedTabData: any = "allSpeakerTypes";
    private filterConfig: any;
    private generalDataConfig: any;

    standardFieldLabels: any = {};
    customFieldLabels: any = {};

    @ViewChild("nav", { read: DragScrollComponent })
    ds: DragScrollComponent;

    constructor(
        private navSecondaryService: CclNavbarSecondaryService,
        public sharedService: SharedService,
        private messageService: CclMessageService,
        private sessionService: SessionService,
        private catalogService: CatalogService
    ) {
        this.navSecondaryService.includeSave = false;
        this.subscription = this.messageService.getMessage().subscribe((message) => this.changeContext(message));
        if (this.sharedService.configs[this.sharedService.configTypes.FILTER_CONFIG] != null) {
            this.filterConfig = JSON.parse(
                this.sharedService.configs[this.sharedService.configTypes.FILTER_CONFIG].config
            );
        }
    }

    ngOnInit() {
        if (this.sharedService.configs[this.sharedService.configTypes.TAB_CONFIG] != null) {
            this.tabConfig = JSON.parse(this.sharedService.configs[this.sharedService.configTypes.TAB_CONFIG].config);
        }
        let speakerTypeArray = [];
        if (this.tabConfig.tabBasedOn === "speakerType") {
            this.generalDataConfig = JSON.parse(
                this.sharedService.configs[this.sharedService.configTypes.DATA.general].config
            );

            if (
                this.generalDataConfig.hasOwnProperty("defaultFilters") &&
                this.generalDataConfig.defaultFilters.speakerTypes.length > 0
            ) {
                this.generalDataConfig.defaultFilters.speakerTypes.forEach((speakerType) => {
                    speakerTypeArray.push({
                        id: speakerType.id,
                        label: speakerType.name
                    });
                });
            } else {
                this.sessionService.getSpeakerTypes(this.sharedService.event.id).subscribe((data) => {
                    if (data.body != null) {
                        this.sharedService.speakerTypes = data.body["content"];

                        this.sharedService.speakerTypes.forEach((speakerType) => {
                            speakerTypeArray.push({
                                id: speakerType.id,
                                label: speakerType.name
                            });
                        });
                    }
                });
            }

            this.tabsData = speakerTypeArray;
        } else {
            this.catalogService
                .getCustomFieldList({
                    eventId: this.sharedService.event.id,
                    objectType: "SPEAKER"
                })
                .subscribe((resp) => {
                    this.sharedService.speakerCustomFields = resp.body["data"];
                    if (this.sharedService.speakerCustomFields != null) {
                        let enumCustomFields = [];
                        let fileCustomFields = [];
                        this.sharedService.speakerCustomFields.forEach((cf) => {
                            if (
                                cf.questionTypeId == 4 ||
                                cf.questionTypeId == 5 ||
                                cf.questionTypeId == 6 ||
                                cf.questionTypeId == 7
                            ) {
                                enumCustomFields.push(cf);
                            } else if (cf.questionTypeId == 19) {
                                fileCustomFields.push(cf);
                            }
                        });
                        this.sharedService.speakerEnumCustomFields = enumCustomFields;
                        this.sharedService.speakerFileCustomFields = fileCustomFields;
                        console.log("speakerEnumCustomFields==", this.sharedService.speakerEnumCustomFields);
                        let cfArray = [];
                        this.sharedService.speakerEnumCustomFields.forEach((cf) => {
                            if (this.tabConfig.tabBasedOn === cf.id) {
                                cf.options.forEach((option) => {
                                    cfArray.push({
                                        id: option.id,
                                        label: option.name,
                                        cfId: cf.id
                                    });
                                });
                            }
                        });
                        this.tabsData = cfArray;
                    }
                });
        }
    }

    ngAfterViewInit(): void {}

    ngOnDestroy() {
        this.sharedService.unsubscribeHelper(this.subscription);
    }

    changeContext(message) {
        if (message.text == "clear-text-search-field") {
            this.selectedTabData = "allSpeakerTypes";
        } else if (message.text == "set-all-day") {
            this.selectedTabData = "allSpeakerTypes";
        }
    }

    selectTab($event, data) {
        if (this.sharedService.generalListLoading) {
            return false;
        }
        if (data === "allSpeakerTypes") {
            this.selectedTabData = data;
        } else {
            this.selectedTabData = data.id;
        }
        this.messageService.sendMessage("changed-tab", data);
    }
    moveLeft() {
        this.ds.moveLeft();
    }

    moveRight() {
        this.ds.moveRight();
    }
}
